import { render, staticRenderFns } from "./viewInfoConfirm.vue?vue&type=template&id=042809a4&"
import script from "./viewInfoConfirm.vue?vue&type=script&lang=js&"
export * from "./viewInfoConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042809a4')) {
      api.createRecord('042809a4', component.options)
    } else {
      api.reload('042809a4', component.options)
    }
    module.hot.accept("./viewInfoConfirm.vue?vue&type=template&id=042809a4&", function () {
      api.rerender('042809a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/viewInfoConfirm.vue"
export default component.exports